import React from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path: string | null;
}

export function breadcrumbLabel(prefix: string, id?: string | null): string {
  return id ? `${prefix} ${id}` : prefix;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex items-center gap-1.5 text-sm list-none">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li
              key={`${item.label}-${index}`}
              className="flex items-center gap-1.5"
            >
              {index > 0 && (
                <span className="text-gray-400 select-none" aria-hidden="true">
                  ›
                </span>
              )}
              {item.path ? (
                <Link
                  to={item.path}
                  className="text-gray-900 hover:text-gray-700 font-medium transition-colors"
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={
                    isLast ? 'text-gray-500 font-medium' : 'text-gray-400'
                  }
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
